import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, loadUser, changePassword } from '../../redux/actions/userAction';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { Container, Form, InputGroup } from 'react-bootstrap';
import SectionHeading from '../common/SectionHeading';
import { AiFillLock, AiFillUnlock } from 'react-icons/ai';
import Loader from '../common/Loader';
import MetaData from '../MetaData';
import { UPDATE_PASSWORD_RESET } from '../../redux/constants/userConstants';
import { BsShieldLockFill } from 'react-icons/bs';

const ChangePassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { error, isUpdated, loading } = useSelector((state) => state.profile);

    const [passwordDetails, setPasswordDetails] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    });

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }

        if (isUpdated) {
            toast.success('Password Updated Successfully');
            dispatch(loadUser());
            // to mark isUpdated = false
            dispatch({ type: UPDATE_PASSWORD_RESET });
            navigate('/account');
        }
    }, [isUpdated, error, isUpdated]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(changePassword(passwordDetails));
    };

    const handleInputChange = (e) => {
        setPasswordDetails({ ...passwordDetails, [e.target.name]: e.target.value });
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title='Update Password' />
            <div className='loginScreen'>
                <Container>
                    <div className='formContainer'>
                        <div className='formContentSection'>
                            <SectionHeading heading={'Update Password'} />
                            <div className='loginRegisterForm'>
                                <form onSubmit={handleSubmit}>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <BsShieldLockFill />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Old Password'
                                            aria-label='password'
                                            name='oldPassword'
                                            type='oldPassword'
                                            value={passwordDetails.oldPassword}
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiFillLock />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='New Password'
                                            aria-label='password'
                                            name='newPassword'
                                            type='newPassword'
                                            value={passwordDetails.newPassword}
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiFillUnlock />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Confirm Password'
                                            aria-label='password'
                                            name='confirmPassword'
                                            type='confirmPassword'
                                            value={passwordDetails.confirmPassword}
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                    <input type='submit' value='Update' className='submitBtn' />
                                </form>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default ChangePassword;
